import { FieldValues, useFormContext, UseFormReturn } from 'react-hook-form';

type ConnectFormProps<TFieldValues extends FieldValues> = {
	children: (
		methods: UseFormReturn<TFieldValues, object>
	) => React.ReactElement;
};

export const ConnectForm = <TFieldValues extends FieldValues>({
	children
}: ConnectFormProps<TFieldValues>) => {
	const methods = useFormContext<TFieldValues>();

	return children({ ...methods });
};
